import { GameConfig } from "../../GameConfig/GameConfig.js";

export default class Weapon {
  constructor() {
    this.image = new Image();

    this.markedForDeletion = false;

    this.frameX = 0;

    this.fps = GameConfig.FPS;
    this.frameTimer = GameConfig.FRAME_TIMER;
    this.frameInterval = GameConfig.FRAME_INTERVAL;
  }

  draw(context, deltaTime) {
    if (this.frameTimer > this.frameInterval) {
      if (this.frameX < this.maxFrame) this.frameX++;
      else this.frameX = 0;
      this.frameTimer = 0;
    } else if (typeof deltaTime == "number") {
      this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
    }

    context.drawImage(
      this.image,
      this.frameX * this.spriteWidth,
      0,
      this.spriteWidth,
      this.spriteHeight,
      this.x,
      this.y,
      this.spriteWidth,
      this.spriteHeight,
    );
  }

  update() {
    this.x += this.speed;
    if (this.x > GameConfig.CANVAS_WIDTH || this.y > GameConfig.CANVAS_HEIGHT) {
      this.markedForDeletion = true;
    }
  }
}
